import { render, staticRenderFns } from "./AuthRegisterOrganisation.vue?vue&type=template&id=7953dfa8&scoped=true"
import script from "./AuthRegisterOrganisation.vue?vue&type=script&lang=js"
export * from "./AuthRegisterOrganisation.vue?vue&type=script&lang=js"
import style0 from "./AuthRegisterOrganisation.vue?vue&type=style&index=0&id=7953dfa8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7953dfa8",
  null
  
)

export default component.exports